var React = require('react');

function Right (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.2949 28.78L24.8749 24.2L20.2949 19.61L21.7049 18.2L27.7049 24.2L21.7049 30.2L20.2949 28.78Z","fill":"#423D33","key":0}),React.createElement("rect",{"x":"0.5","y":"0.699951","width":"47","height":"47","rx":"23.5","stroke":"#423D33","key":1})]);
}

Right.defaultProps = {"width":"48","height":"49","viewBox":"0 0 48 49","fill":"none"};

module.exports = Right;

Right.default = Right;
